<template>
  <div>
    <!-- 经典页面 -->
    <div>
      <ul class="tabbar">
        <template v-for="(item, index) in navBar">
          <li
            :key="index"
            :class="index == navIdx ? 'active' : ''"
            @click.stop="changeNav(index)"
          >
            {{ item }}
          </li>
        </template>
      </ul>

      <div class="card-wrap">
        <blog-card v-for="blog in blogs" :key="blog.blogId" :blog="blog">
        </blog-card>
      </div>
    </div>

    <template v-if="blogs.length">
      <div class="btn-wrap" v-if="blogs.length < allBlogs.length">
        <button class="primary-btn plain" @click.stop="loadmore">
          加载更多
        </button>
      </div>
      <div v-else class="no-data">
        <span>~ 已加载全部 ~</span>
      </div>
    </template>
    <template v-else>
      <div class="img-wrap">
        <img src="@/assets/images/no-data.png" alt="" />
        <div class="no-data">暂无数据</div>
      </div>
    </template>
  </div>
</template>

<script>
import data from "./index.js";
export default data;
</script>
